import type { RouteRecordRaw } from 'vue-router';
import { buildRootURL } from '@centric-os/helpers';
import { InventoryRoutePathNames, InventoryRouteNames } from './enums';

const App = () => import('./App.vue');

export * from './enums';

export const route: RouteRecordRaw = {
  path: buildRootURL(InventoryRoutePathNames.Inventory),
  name: InventoryRouteNames.INVENTORY_ROOT,
  meta: {
    requireAuth: true,
  },
  component: App,
};
